import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../Context/AuthenticateProvider";

const PublicRouter = () => {
  const { isAuthenticated } = useAuth();
  console.log("Public Router")
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PublicRouter;